<script setup>
import { HoverCardRoot, useForwardPropsEmits } from "reka-ui";

const props = defineProps({
  defaultOpen: { type: Boolean, default: undefined },
  open: { type: Boolean, default: undefined },
  openDelay: { type: Number, default: 0 },
  closeDelay: { type: Number, default: 0 },
});

const emits = defineEmits(["update:open"]);

const forwarded = useForwardPropsEmits(props, emits);
</script>

<template>
  <HoverCardRoot v-bind="forwarded" data-slot="hover-card">
    <slot />
  </HoverCardRoot>
</template>
